import { FC, useEffect, useLayoutEffect } from 'react';

import Helmet from '@/components/meta/Helmet';
import GlossaryTemplate from '@/components/templates/Glossary';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';

const GlossaryPage: FC = () => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  useEffect(() => {
    setBreadcrumbs([
      {
        name: '競輪用語集',
        to: '',
      },
    ]);
  }, []);

  useLayoutEffect(() => {
    setLayoutStyles();
  }, []);

  return (
    <>
      <Helmet
        meta={{
          title: '競輪用語集',
          description: '競輪用語集ページです。%s',
        }}
      />
      <GlossaryTemplate />
    </>
  );
};

export default GlossaryPage;
